import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=89804c34&scoped=true&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"
import style0 from "./Tab.vue?vue&type=style&index=0&id=89804c34&scoped=true&lang=css&"
import style1 from "./Tab.vue?vue&type=style&index=1&id=89804c34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89804c34",
  null
  
)

export default component.exports